<div
  class="dialog-shell resize-container"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  (cdkDragEnded)="savePosition($event)"
  #drag="cdkDrag">

  <div class="dialog-shell__header" cdkDragHandle>
    <div class="dialog-shell__title">
      <span class="dialog-shell__accent"></span>
      <span>{{ title }}</span>
    </div>

    <button
      mat-icon-button
      type="button"
      class="dialog-shell__close"
      (click)="close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-shell__body">
    <ng-container #container></ng-container>
  </div>

</div>
